import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Layout } from './components/layout/Layout';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Login } from './modules/auth/Login';
import { Dashboard } from './modules/Dashboard';
import { Usuarios } from './modules/cadastros/Usuarios';
import { Clientes } from './modules/cadastros/Clientes';
import { ExtratoCliente } from './modules/cadastros/ExtratoCliente';
import { Fornecedores } from './modules/cadastros/Fornecedores';
import { ComprasFornecedor } from './modules/cadastros/ComprasFornecedor';
import { ListaSimples } from './modules/cadastros/ListaSimples';
import { MetasMargem } from './modules/cadastros/MetasMargem';
import { UnidadesMedida } from './modules/cadastros/UnidadesMedida';
import { Cidades } from './modules/cadastros/Cidades';
import { Localizacoes } from './modules/cadastros/Localizacoes';
import { LocalizacoesProdutos } from './modules/estoque/LocalizacoesProdutos';
import { EstoquePorPrateleira } from './modules/estoque/EstoquePorPrateleira';
import { Inconsistencias } from './modules/estoque/Inconsistencias';
import { Reposicoes } from './modules/estoque/Reposicoes';
import Conferencia from './modules/estoque/Conferencia';
import AuditoriaEstoque from './modules/estoque/AuditoriaEstoque';
import VendasPerdidas from './modules/estoque/VendasPerdidas';
import PremioEstoque from './modules/equipe/PremioEstoque';
import { TransferirEstoque } from './modules/estoque/TransferirEstoque';
import { SituacoesTributarias } from './modules/cadastros/SituacoesTributarias';
import { ProdutosLista } from './modules/produtos/ProdutosLista';
import { ProdutoForm } from './modules/produtos/ProdutoForm';
import { CatalogoGestao } from './modules/produtos/CatalogoGestao';
import { GestaoFotos } from './modules/gestao-fotos/GestaoFotos';
import { OrcamentosHome } from './modules/orcamentos/OrcamentosHome';
import { OrcamentoNovo } from './modules/orcamentos/OrcamentoNovo';
import { TelaUnicaOrcamento } from './modules/orcamentos/TelaUnicaOrcamento';
import { FilaRetomada } from './modules/orcamentos/FilaRetomada';
import { RemessaView } from './modules/orcamentos/RemessaView';
import { Leitor } from './modules/ler/Leitor';
import { CotacoesHome } from './modules/cotacoes/CotacoesHome';
import { CotacaoNovaSimples } from './modules/cotacoes/CotacaoNovaSimples';
import { CotacaoRespostas } from './modules/cotacoes/CotacaoRespostas';
import { CotacaoComparativo } from './modules/cotacoes/CotacaoComparativo';
import { CompraInformativa } from './modules/cotacoes/CompraInformativa';
import { FaltaComprar } from './modules/cotacoes/FaltaComprar';
import { MaisVendidos } from './modules/cotacoes/MaisVendidos';
import { CatalogoFornecedor } from './modules/cotacoes/CatalogoFornecedor';
import NovosProdutos from './modules/novos-produtos/NovosProdutos';
import { MonitorPrecos } from './modules/cotacoes/MonitorPrecos';
import { RastreioProduto } from './modules/cotacoes/Rastreio';
import { ListaCompras } from './modules/cotacoes/ListaCompras';
import { NotasEntradaLista } from './modules/notas-entrada/NotasEntradaLista';
import { NotaEntradaImportar } from './modules/notas-entrada/NotaEntradaImportar';
import { NotaEntradaRevisarMargens } from './modules/notas-entrada/NotaEntradaRevisarMargens';
import { NotaEntradaRatear } from './modules/notas-entrada/NotaEntradaRatear';
import { ContasReceberLista } from './modules/contas-receber/ContasReceberLista';
import { ContasPagarLista } from './modules/contas-pagar/ContasPagarLista';
import { NotasFiscaisLista } from './modules/notas-fiscais/NotasFiscaisLista';
import { CaixaPainel } from './modules/caixa/CaixaPainel';
import { FinanceiroPainel } from './modules/caixa/FinanceiroPainel';
import { ExibicaoPix } from './modules/caixa/ExibicaoPix';
import { TrocasHome } from './modules/trocas/TrocasHome';
import { PromocoesPage } from './modules/promocoes/PromocoesPage';
import { PontoRegistrar } from './modules/equipe/PontoRegistrar';
import { PontoEntradaDoDia } from './modules/equipe/PontoEntradaDoDia';
import { Equipe } from './modules/equipe/Equipe';
import { ComissoesPainel } from './modules/equipe/ComissoesPainel';
import { ComissoesConfig } from './modules/equipe/ComissoesConfig';
import { EstatisticasAgentes } from './modules/equipe/EstatisticasAgentes';
import { DiarioUsuario } from './modules/equipe/DiarioUsuario';
import { Cores } from './modules/configuracoes/Cores';
import { Recebimentos } from './modules/configuracoes/Recebimentos';
import { DispositivosAutorizados } from './modules/configuracoes/DispositivosAutorizados';
import UsuariosAppCel from './modules/configuracoes/UsuariosAppCel';
import { Fiscal as ConfigFiscal } from './modules/configuracoes/Fiscal';
import { RDS } from './modules/configuracoes/RDS';
import { CatalogoComponentes } from './modules/configuracoes/CatalogoComponentes';
import { ParceiroPrograma } from './modules/configuracoes/ParceiroPrograma';
import { ManualPage } from './modules/manual/ManualPage';
import { TreinamentoPage } from './modules/treinamento/TreinamentoPage';
import { ConsignacaoClientes } from './modules/financeiro/ConsignacaoClientes';
import { AtendimentoHome } from './modules/atendimento/AtendimentoHome';
import { Telao } from './modules/atendimento/Telao';
import { CatalogoPublicoLista } from './modules/catalogo-publico/CatalogoPublicoLista';
import { CatalogoPublicoProduto } from './modules/catalogo-publico/CatalogoPublicoProduto';
import { CatalogoPublicoPrivacidade } from './modules/catalogo-publico/CatalogoPublicoPrivacidade';
import { CatalogoPublicoTrocas } from './modules/catalogo-publico/CatalogoPublicoTrocas';
import { CatalogoPublicoTermos } from './modules/catalogo-publico/CatalogoPublicoTermos';
import AppCliente from './modules/app-cliente/AppCliente';
import { CatalogoPublicoLoja } from './modules/catalogo-publico/CatalogoPublicoLoja';

function ExigirAuth({ children }: { children: React.ReactNode }) {
  const { usuario, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div style={{ padding: 40 }}>Carregando...</div>;
  if (!usuario) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return <>{children}</>;
}

/**
 * Conta de APARELHO (o celular do balcao) nao abre o ERP — vai direto pro Pix.
 *
 * ⚠️ Sem isto o quiosque cai no Dashboard e ve uma tela de destrocos: o servidor recusa as
 * ~16 faixas de alerta, os cards nao carregam e nada explica por que. **403 no lugar certo
 * ainda e' uma tela errada** — o servidor diz "nao pode", e cabe a navegacao nao levar
 * ninguem la. O confinamento de verdade mora no `ALCANCE_QUIOSQUE` (servidor); isto aqui e'
 * so a porta certa, e por isso le `usuario.quiosque` (que vem do `/me`) em vez de nome de
 * login escrito no front — a trava por lista de nome foi revertida na [DA-543].
 *
 * O AppCel (`/app`) fica de FORA por construcao: ele e' rota irma, nao passa por aqui.
 */
function ForaDoAlcanceDoQuiosque({ children }: { children: React.ReactNode }) {
  const { usuario, loading } = useAuth();
  if (!loading && usuario?.quiosque) return <Navigate to="/balcao/pix" replace />;
  return <>{children}</>;
}

/**
 * Nao bateu a entrada? A unica tela do sistema e' a de bater ponto.
 *
 * Decisao do Ruan (31/08/2026): *"o ponto deve ser a primeira acao do dia"*. O que
 * confina de verdade e' o `exigirPontoDoDia` no servidor; isto aqui e' so a porta certa —
 * mesma divisao de trabalho do quiosque logo acima, e pelo mesmo motivo, que aquele
 * comentario ja descreve: sem o desvio a pessoa cai no Dashboard e ve destrocos, porque o
 * servidor recusa as ~16 faixas de alerta e nada explica por que.
 *
 * ⚠️ **O destino e' a rota IRMA `/ponto/entrada-do-dia`, que vive FORA do `<Layout>`** —
 * nao a `/ponto/registrar`, que fica dentro dele. Mandar pra dentro do Layout reporia
 * exatamente a tela de destrocos que este wrapper existe pra evitar: o chassi dispara as
 * faixas de alerta ao montar, e todas voltariam 403. E' o mesmo desenho do `/balcao/pix`.
 */
function ExigirPontoDoDia({ children }: { children: React.ReactNode }) {
  const { usuario, loading } = useAuth();
  if (!loading && usuario?.ponto_pendente) return <Navigate to="/ponto/entrada-do-dia" replace />;
  return <>{children}</>;
}

function RedirecionarSeLogado({ children }: { children: React.ReactNode }) {
  const { usuario, loading } = useAuth();
  if (loading) return <div style={{ padding: 40 }}>Carregando...</div>;
  if (usuario) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<RedirecionarSeLogado><Login /></RedirecionarSeLogado>} />
        {/* Catalogo publico (sem auth) — Onda Catalogo Fase 1b/2 */}
        <Route path="/catalogo" element={<CatalogoPublicoLista />} />
        {/* /p/:slugId e a URL canonica curta. /catalogo/:slugId fica como fallback caso server nao redirecione. */}
        <Route path="/p/:slugId" element={<CatalogoPublicoProduto />} />
        <Route path="/catalogo/:slugId" element={<CatalogoPublicoProduto />} />
        <Route path="/privacidade" element={<CatalogoPublicoPrivacidade />} />
        <Route path="/trocas-e-devolucoes" element={<CatalogoPublicoTrocas />} />
        <Route path="/termos" element={<CatalogoPublicoTermos />} />
        <Route path="/a-loja" element={<CatalogoPublicoLoja />} />
        {/* Aplicativo do cliente (sem auth de equipe) — cadastro/entrada + chat com a loja.
            Credencial propria (`tipo: 'cliente'`), recusada pelas rotas do ERP. RDS chamados 1.27. */}
        <Route path="/app" element={<AppCliente />} />
        {/* `/app/<token>` e o link de 1o acesso. O token vai no CAMINHO (e nao em
            `?c=`) porque o endereco viaja num balao de WhatsApp — ver `convites.service`.
            A mesma tela atende as duas rotas; o formato antigo segue lido. */}
        <Route path="/app/:token" element={<AppCliente />} />
        <Route
          path="/atendimento/telao"
          element={
            <ExigirAuth>
              <Telao />
            </ExigirAuth>
          }
        />
        {/* Tela de exibição do Pix no balcão (celular do Atendimento) — full-screen, fora do Layout */}
        <Route
          path="/balcao/pix"
          element={
            <ExigirAuth>
              <ErrorBoundary>
                <ExibicaoPix />
              </ErrorBoundary>
            </ExigirAuth>
          }
        />
        {/* Bater a ENTRADA do dia — full-screen, fora do Layout, pelo mesmo motivo do
            /balcao/pix logo acima: quem esta aqui tem `/api/*` recusado inteiro, entao o
            chassi do ERP nao pode montar (as faixas de alerta dele voltariam todas 403).
            A `/ponto/registrar` de dentro do Layout continua existindo e e' por onde quem
            JA bateu registra o almoco e a saida. */}
        <Route
          path="/ponto/entrada-do-dia"
          element={
            <ExigirAuth>
              <ErrorBoundary>
                <PontoEntradaDoDia />
              </ErrorBoundary>
            </ExigirAuth>
          }
        />
        <Route
          path="/*"
          element={
            <ExigirAuth>
              <ForaDoAlcanceDoQuiosque>
              <ExigirPontoDoDia>
              <Layout>
                <ErrorBoundary>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/cadastros/usuarios" element={<Usuarios />} />
                  <Route path="/cadastros/clientes" element={<Clientes />} />
                  <Route path="/clientes/:id/extrato" element={<ExtratoCliente />} />
                  <Route path="/cadastros/fornecedores" element={<Fornecedores />} />
                  <Route path="/fornecedores/:id/compras" element={<ComprasFornecedor />} />
                  <Route path="/cadastros/grupos" element={<ListaSimples titulo="Grupos" recurso="grupos" ativoVal="ativo" inativoVal="inativo" />} />
                  <Route path="/cadastros/categorias" element={<ListaSimples titulo="Categorias" recurso="categorias" ativoVal="ativa" inativoVal="inativa" soAdmin comMeta comProdutos />} />
                  <Route path="/cadastros/marcas" element={<ListaSimples titulo="Marcas" recurso="marcas" ativoVal="ativa" inativoVal="inativa" />} />
                  <Route path="/cadastros/categorias-despesa" element={<ListaSimples titulo="Categorias de Despesa" singular="Categoria de Despesa" recurso="categorias-despesa" ativoVal="ativa" inativoVal="inativa" />} />
                  {/* As opcoes do "Como conheceu a loja?" do Enviar ao Caixa (migration 0322). */}
                  <Route path="/cadastros/origens-cliente" element={<ListaSimples titulo="Origem do Cliente" singular="Origem" recurso="origens-cliente" ativoVal="ativa" inativoVal="inativa" soAdmin />} />
                  <Route path="/cadastros/unidades-medida" element={<UnidadesMedida />} />
                  <Route path="/cadastros/cidades" element={<Cidades />} />
                  <Route path="/cadastros/metas-margem" element={<MetasMargem />} />
                  <Route path="/cadastros/localizacoes" element={<Localizacoes />} />
                  <Route path="/estoque/conferencia" element={<Conferencia />} />
                  <Route path="/estoque/localizacoes" element={<LocalizacoesProdutos />} />
                  <Route path="/estoque/prateleiras" element={<EstoquePorPrateleira />} />
                  <Route path="/estoque/reposicoes" element={<Reposicoes />} />
                  <Route path="/estoque/transferir" element={<TransferirEstoque />} />
                  <Route path="/estoque/inconsistencias" element={<Inconsistencias />} />
                  {/* Premio do Estoquista (DA-868) — o servidor cobra admin/gerente nas rotas. */}
                  <Route path="/estoque/auditoria" element={<AuditoriaEstoque />} />
                  <Route path="/vendas-perdidas" element={<VendasPerdidas />} />
                  <Route path="/configuracoes/situacoes-tributarias" element={<SituacoesTributarias />} />
                  <Route path="/produtos" element={<ProdutosLista />} />
                  <Route path="/produtos/:id" element={<ProdutoForm />} />
                  <Route path="/catalogo-gestao" element={<CatalogoGestao />} />
                  <Route path="/promocoes" element={<PromocoesPage />} />
                  <Route path="/orcamentos" element={<OrcamentosHome />} />
                  <Route path="/orcamentos/novo" element={<TelaUnicaOrcamento><OrcamentoNovo /></TelaUnicaOrcamento>} />
                  {/* Antes da `/orcamentos/:id` de proposito — declarada depois, o `:id` a engole. */}
                  <Route path="/orcamentos/fila" element={<FilaRetomada />} />
                  {/* Consignacao Fase 2 (DA-376): tela dedicada read-only da remessa emitida.
                      Rota literal (segmento /remessa) — a aba Remessas e a /:id redirecionam pra ca. */}
                  <Route path="/orcamentos/:id/remessa" element={<RemessaView />} />
                  <Route path="/orcamentos/:id" element={<TelaUnicaOrcamento><OrcamentoNovo /></TelaUnicaOrcamento>} />
                  <Route path="/ler" element={<Leitor />} />
                  <Route path="/cotacoes" element={<CotacoesHome />} />
                  <Route path="/cotacoes/nova" element={<CotacaoNovaSimples />} />
                  {/* Compra informativa (DA-309) — rota literal ANTES de /cotacoes/:id/... */}
                  <Route path="/cotacoes/informativa/nova" element={<CompraInformativa />} />
                  {/* Falta comprar (DA-368 Fase 2) — rota literal ANTES de /cotacoes/:id/... */}
                  <Route path="/cotacoes/falta-comprar" element={<FaltaComprar />} />
                  <Route path="/cotacoes/mais-vendidos" element={<MaisVendidos />} />
                  <Route path="/cotacoes/:id/informativa" element={<CompraInformativa />} />
                  <Route path="/cotacoes/:id/respostas" element={<CotacaoRespostas />} />
                  <Route path="/cotacoes/:id/comparativo" element={<CotacaoComparativo />} />
                  <Route path="/catalogo-fornecedor" element={<CatalogoFornecedor />} />
                  <Route path="/novos-produtos" element={<NovosProdutos />} />
                  <Route path="/monitor-precos" element={<MonitorPrecos />} />
                  <Route path="/rastreio" element={<RastreioProduto />} />
                  <Route path="/lista-compras" element={<ListaCompras />} />
                  <Route path="/notas-entrada" element={<NotasEntradaLista />} />
                  <Route path="/notas-entrada/importar" element={<NotaEntradaImportar />} />
                  {/* Antes de /:id/... — "ratear" nao pode ser lido como id de nota ([DA-679]). */}
                  <Route path="/notas-entrada/ratear" element={<NotaEntradaRatear />} />
                  <Route path="/notas-entrada/:id/revisar-margens" element={<NotaEntradaRevisarMargens />} />
                  <Route path="/contas-receber" element={<ContasReceberLista />} />
                  <Route path="/contas-pagar" element={<ContasPagarLista />} />
                  <Route path="/consignacao" element={<ConsignacaoClientes />} />
                  <Route path="/notas-fiscais" element={<NotasFiscaisLista />} />
                  <Route path="/gestao-fotos" element={<GestaoFotos />} />
                  <Route path="/caixa" element={<CaixaPainel />} />
                  <Route path="/financeiro" element={<FinanceiroPainel />} />
                  <Route path="/trocas" element={<TrocasHome />} />
                  <Route path="/ponto/registrar" element={<PontoRegistrar />} />
                  <Route path="/equipe" element={<Equipe />} />
                  <Route path="/equipe/estatisticas-agentes" element={<EstatisticasAgentes />} />
                  <Route path="/equipe/diario" element={<DiarioUsuario />} />
                  <Route path="/comissoes" element={<ComissoesPainel />} />
                  <Route path="/comissoes/configurar" element={<ComissoesConfig />} />
                  <Route path="/equipe/premio-estoque" element={<PremioEstoque />} />
                  <Route path="/configuracoes/cores" element={<Cores />} />
                  <Route path="/configuracoes/fiscal" element={<ConfigFiscal />} />
                  <Route path="/configuracoes/recebimentos" element={<Recebimentos />} />
                  <Route path="/configuracoes/dispositivos" element={<DispositivosAutorizados />} />
                  <Route path="/configuracoes/appcel" element={<UsuariosAppCel />} />
                  <Route path="/configuracoes/rds" element={<RDS />} />
                  <Route path="/configuracoes/catalogo" element={<CatalogoComponentes />} />
                  <Route path="/configuracoes/programas/parceiro" element={<ParceiroPrograma />} />
                  <Route path="/manual" element={<ManualPage />} />
                  <Route path="/manual/:slug" element={<ManualPage />} />
                  <Route path="/treinamento" element={<TreinamentoPage />} />
                  <Route path="/treinamento/:slug" element={<TreinamentoPage />} />
                  <Route path="/atendimento" element={<AtendimentoHome />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                </ErrorBoundary>
              </Layout>
              </ExigirPontoDoDia>
              </ForaDoAlcanceDoQuiosque>
            </ExigirAuth>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
